import React, { Component } from 'react'
import { Layout } from 'antd'
import { Route, Switch, Redirect } from 'react-router-dom'
import { userIsAuthenticatedRedir, userIsNotAuthenticatedRedir } from '../security/Auth'
import ErrorBoundary from '../components/ErrorBoundary'
import Analytics from '../components/Analytics'
import Loadable from 'react-loadable'
import Home from '../components/home'
import NavBar from '../components/layout/NavBar'
import LoadingComponent from '../components/LoadingComponent'
import UserService from '../services/UserService'
import { login } from '../actions/UserActions'
import store from '../store/configureStore'
import LogrocketConfig from '../utils/LogrocketConfig'
import { setGlobalCSRF } from '../utils/Util'
import history from '../components/history'

const BookingContainer = Loadable({
  loader: () => import('./BookingContainer'),
  loading: LoadingComponent
})

const Profile = Loadable({
  loader: () => import('../components/profile'),
  loading: LoadingComponent
})
const MyGarage = Loadable({
  loader: () => import('../components/garage'),
  loading: LoadingComponent
})
const ServicePage = Loadable({
  loader: () => import('../components/servicepage'),
  loading: LoadingComponent
})
const FAQ = Loadable({
  loader: () => import('../components/faq'),
  loading: LoadingComponent
})
const About = Loadable({
  loader: () => import('../components/about'),
  loading: LoadingComponent
})
const Privacy = Loadable({
  loader: () => import('../components/Privacy'),
  loading: LoadingComponent
})
const Terms = Loadable({
  loader: () => import('../components/Terms'),
  loading: LoadingComponent
})
const Footer = Loadable({
  loader: () => import('../components/layout/Footer'),
  loading() {
    return null
  }
})
const ResetPassword = Loadable({
  loader: () => import('../components/login/ResetPassword'),
  loading: LoadingComponent
})
const ProfileUpdateSuccess = Loadable({
  loader: () => import('../components/profile/ProfileUpdateSuccess'),
  loading: LoadingComponent
})
const LoginPage = Loadable({
  loader: () => import('../components/login/LoginPage'),
  loading: LoadingComponent
})

const CarsWeServicePage = Loadable({
  loader: () => import('../components/seo/CarsWeService'),
  loading: LoadingComponent
})
const CitiesWeServePage = Loadable({
  loader: () => import('../components/seo/CitiesWeServe'),
  loading: LoadingComponent
})
const Partners = Loadable({
  loader: () => import('../components/seo/OurPartners'),
  loading: LoadingComponent
})
const ServiceDetailsPage = Loadable({
  loader: () => import('../components/servicepage/ServiceDetails'),
  loading: LoadingComponent
})
const ThankYouPage = Loadable({
  loader: () => import('../components/thankyou'),
  loading: LoadingComponent
})
const BookingSchedulerPage = Loadable({
  loader: () => import('../components/booking/BookingScheduler'),
  loading: LoadingComponent
})
const { Header, Content } = Layout

class AppContainer extends Component {
  componentDidMount() {
    LogrocketConfig.init()
    setGlobalCSRF()
    this.getUserData()
  }

  async getUserData() {
    const response = await UserService.loginUsingCookie()
    if (response) {
      store.dispatch(login(response))
      history.push('/my-garage')
    }
  }

  render() {
    return (
      <ErrorBoundary>
        {Analytics.init() && <Analytics.RouteTracker />}
        <Layout className="automech-layout">
          <div className="automech-main">
            <Header>
              <NavBar />
            </Header>
            <Content>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/service" component={ServicePage} />
                <Route path="/service/:serviceDetail" component={ServiceDetailsPage} />
                <Route exact path="/faq" component={FAQ} />
                <Route exact path="/about" component={About} />
                <Route exact path="/privacy" component={Privacy} />
                <Route exact path="/terms" component={Terms} />
                <Route exact path="/partners" component={Partners} />
                <Route path="/cars" component={CarsWeServicePage} />
                <Route path="/cities" component={CitiesWeServePage} />
                <Route
                  path="/profile"
                  component={userIsAuthenticatedRedir(Profile)}
                  //component={Profile}
                />
                <Route path="/my-garage" component={userIsAuthenticatedRedir(MyGarage)} />
                <Route path="/availability" component={BookingSchedulerPage} />
                <Route exact path="/login" component={userIsNotAuthenticatedRedir(LoginPage)} />
                <Route path="/booking" component={BookingContainer} />
                <Route path="/thankyou" component={ThankYouPage} />
                <Route path="/profileupdated" component={ProfileUpdateSuccess} />
                <Route path="/reset/:token" component={ResetPassword} />
                <Redirect to="/" />
              </Switch>
            </Content>
          </div>
          <Footer />
        </Layout>
      </ErrorBoundary>
    )
  }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js